import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class DepedentMember  {
    _originalTypeClassName = "zERP.BO.DepedentMember";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
DepedentMember.translate = translateService;
}
this.Id = null;
this.FirstName = null;
this.LastName = null;
this.BirthDate = null;
this.Gender = null;
this.AMKA = null;
this.FamilyStatus = null;
this.Relationship = null;
this.DisabilityPrct = 0;
this.PrivateInsurance = false;
this.PrivateInsuranceStartDate = null;
this.PrivateInsuranceExpires = null;
this.EducationStart = null;
this.EducationDuration = null;
this.Enlisted = false;
this.DepMemberEducation = null;
this.Code = null;
this.hasActiveContract = false;
this.State = null;
this.EmpComment = null;
this.HRComment = null;
this.FMY = null;
this.EducationYears = null;
this.EducationMonths = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
FirstName:any;
LastName:any;
BirthDate:any;
Gender:any;
AMKA:any;
FamilyStatus:any;
Relationship:any;
DisabilityPrct:any;
PrivateInsurance:any;
PrivateInsuranceStartDate:any;
PrivateInsuranceExpires:any;
EducationStart:any;
EducationDuration:any;
Enlisted:any;
DepMemberEducation:any;
Code:any;
hasActiveContract:any;
State:any;
EmpComment:any;
HRComment:any;
FMY:any;
EducationYears:any;
EducationMonths:any;
Employee:any;
static setEmployee = ($this, value) => {
var oldValue = $this.Employee;
$this.Employee = value;
if (value != null) {
if (oldValue != null) {
Domain.Employee.removeDepedentMember(oldValue, $this);
}
Domain.Employee.addDepedentMember(value, $this);
}
}

static CalculateFamilyProvisionAge($this: any): any{return Joove.Common.safeNumber(Joove.Common.dateDiff(moment().toDate(), $this?.BirthDate)?.days) / Joove.Common.safeNumber(365);
}
static EducationDurationToDays(educationStartDate: any,educationYears: any,educationMonths: any): any{let totalMonths = Joove.Common.safeNumber((Joove.Common.safeNumber(educationYears) * Joove.Common.safeNumber(12))) + Joove.Common.safeNumber(educationMonths);
let educationEndDate = (moment(educationStartDate).add(totalMonths, "M")).toDate();
let diff = Joove.Common.dateDiff(educationEndDate, educationStartDate);
return diff?.days;
}
static EducationDurationToMonths(depMember: any): any{let totalMonths = null;
let endDate = (moment(depMember?.EducationStart).add(depMember?.EducationDuration, "d")).toDate();
totalMonths = Math.abs(Joove.Common.safeNumber((moment(endDate).month() + 1)) - Joove.Common.safeNumber((moment(depMember?.EducationStart).month() + 1)));
return totalMonths;
}
static EducationDurationToYears(depMember: any): any{return Joove.Common.safeNumber(depMember?.EducationDuration) / Joove.Common.safeNumber(365);
}
static GetClassName(): any{return "DepedentMember";
}
static GetEducationEndDate($this: any): any{let educationEndDate = (moment((moment((moment($this?.EducationStart).add($this?.EducationYears, "y")).toDate()).add($this?.EducationMonths, "M")).toDate()).add(-1, "d")).toDate();
console.warn("EducationEndDate " + educationEndDate);
return educationEndDate;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}